<div class="panel" [class.is-read]="!isNotRead()">
  <div class="panel_content">
    <!-- The column stays even when the icon goes: .panel_content is a flex row,
         so removing it outright would drop its width AND the 10px gap, shifting
         every read row's text ~34px left of the unread rows stacked above it. -->
    <div class="icon-slot">
      <ion-icon name="warning-outline" class="icon" *ngIf="isNotRead()"></ion-icon>
    </div>
    <div class="panel_content-text">
      <span class="sev" [ngClass]="severityClass">{{severityLabel}}</span>
      <span class="title" *ngIf="alert.title">{{alert.title}}</span>
      <span>{{alert.text}}</span>
      <div class="panel_footer">
        <span class="date">
          {{formatDate(alert.createdAt)}}
        </span>
        <ion-checkbox [checked]="!isNotRead()" (ionChange)="toggleAlertReadState($event)"></ion-checkbox>
      </div>
    </div>
  </div>
</div>
